module.exports = __webpack_public_path__ + "/content/skins/tfs/img/logo.png";